import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Case_Arrow } from "../../../app-constants";
import { Link } from "gatsby";
import Logo1 from "../../images/location_new/caseimg/logo1.webp";
import Img1 from "../../images/location_new/caseimg/img1.webp";
import Logo2 from "../../images/location_new/caseimg/logo2.webp";
import Img2 from "../../images/location_new/caseimg/img2.webp";
import Logo8 from "../../images/location_new/caseimg/logo8.webp";
import Img8 from "../../images/location_new/caseimg/img8.webp";
import Logo9 from "../../images/location_new/caseimg/logo9.webp";
import Img9 from "../../images/location_new/caseimg/img9.webp";

const CaseStudy = [
  {
    logo: Logo1,
    title: "The Idea Behind Nurse Practitioners",
    description:
      "The Nurse Practitioners app is meticulously crafted with a singular purpose: to transform healthcare and showcase technologys positive influence on the end-users.",
    link: "nurse-practitioners",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: {
      src: Img1,
      alt: "mobile app development company new york",
    },
    BgColor: "#d5ccee",
    TextColor: "#6d4fc1",
  },
  {
    logo: Logo2,
    title: "The Idea Behind MoCuts",
    description:
      "MoCuts Pro serves as a digital marketplace connecting users with certified barbers, beauticians, and everyday grooming services, simplifying the booking process.",
    link: "mocuts",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: {
      src: Img2,
      alt: "app development nyc",
    },
    BgColor: "#fff3f2",
    TextColor: "#78332a",
  },
  {
    logo: Logo8,
    title: "The Idea Behind Onsite Social",
    description:
      "OnSite Social, a TekRevol creation, bridges the physical and digital realms, forging meaningful real-time connections among users.",
    link: "onsite",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: {
      src: Img8,
      alt: "app developers new york",
    },
    BgColor: "#f3faff",
    TextColor: "#54a4c9",
  },
  {
    logo: Logo9,
    title: "The Idea Behind Pure Plank",
    description:
      "Pure Plank, an online platform for health and fitness enthusiasts dedicated to maintaining well-being and exercise routines in the comfort of their homes.",
    link: "pure-plank",
    technology: {
      iOS: "iOS",
      Android: "Android",
    },
    Img: {
      src: Img9,
      alt: "mobile app development nyc",
    },
    BgColor: "#19181e66",
    TextColor: "#97f084",
  },
];

function Stories(props) {
  return (
    <div className="section_stories p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="Success">
              <h2> TekRevol’s Success Stories</h2>
            </div>
            <p>
              TekRevol's leading position in New York's mobile app market
              reflects our ability to effectively fuse technology to craft
              state-of-the-art solutions. Our previous endeavours and mobile app
              projects have made an impact on startups & well-established
              enterprises. Our position as an establishing force in New York's
              mobile app market aligns with our successful partnerships,
              integrating technology to produce cutting-edge solutions. Immerse
              yourself in TekRevol's successful ventures and launch your
              business with us.
            </p>
          </Col>
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="my-auto"
              key={index}
            >
              <div
                className="stories_item"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="item_logo">
                  <LazyLoadImage
                    src={item.logo}
                    effect="blur"
                    alt={item.title}
                    className="img-fluid"
                  />
                  <ul
                    style={{
                      color: item.TextColor,
                      borderColor: item.TextColor,
                    }}
                  >
                    <li>{item.technology.iOS}</li>
                    <li>{item.technology.Android}</li>
                  </ul>
                </div>
                <div className="item_tech">
                  <div className="tech_content">
                    <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                    <p>{item.description}</p>

                    <Link
                      to={
                        item.link
                          ? `/case-studies/${item.link}`
                          : "https://www.tekrevol.com/projects"
                      }
                      className="case_btn"
                      aria-label="TekRevol Contact"
                      style={{ backgroundColor: item.TextColor }}
                    >
                      View Case Study {Case_Arrow}
                    </Link>
                  </div>
                  <div className="tech_img">
                    <LazyLoadImage
                      src={item.Img.src}
                      effect="blur"
                      alt={item.Img.alt}
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Stories;
